import type { CareQueueItem } from "@/api/careQueue";

export function CareHistory({ item }: { item: CareQueueItem }) {
  if (!item.activities?.length) return null;
  return <section aria-label="Care history" className="mt-4 space-y-3 border-t border-slate-700 pt-4 text-sm">
    <h4 className="font-semibold text-white">Care history</h4>
    {item.activities.map(activity => <div key={activity.id}>
      <p className="font-medium text-slate-200">{activity.type === "COMPLETION_NOTE" ? "Completed" : "Reopened"}: {new Date(activity.created_at).toLocaleString()}</p>
      {activity.author_name && <p className="text-slate-400">{activity.type === "COMPLETION_NOTE" ? "Completed by" : "Reopened by"}: {activity.author_name}</p>}
      {activity.comment && <p className="mt-1 whitespace-pre-wrap break-words text-slate-200">Completion note: {activity.comment}</p>}
    </div>)}
  </section>;
}
